import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/configuration/team')({
  component: Outlet,
  head: () => ({ meta: [{ title: 'Team' }] }),
});
